/// <amd-module name="Core/Medius.Core.Web/Scripts/Medius/core/viewmodels/mapping/collection/instance"/>
import { dataTransferMappingCollectionFactory } from "Core/Medius.Core.Web/Scripts/Medius/core/viewmodels/mapping/collection/implementation";
export = dataTransferMappingCollectionFactory();